// constants
import { VOUCHER_ENTITY_CARD_TYPES } from "@dineout-payment-success-ui/constants";

// interfaces
import {
    IMetaData,
    IVoucherEntityCard,
    IVoucherEntityCardData,
    IVoucherEntityResponse,
    IVoucherSkuCard,
} from "@dineout-payment-success-ui/interfaces";
import { type ICouponMetaData } from "@swiggy-private/dls-web-recipe-do-web/dist/components/PurchasedCouponCard";

// internal-deps
import { isEqual } from "@swiggy-private/js-utils";

const DINE_CASH_ICON_URL = "portal/static-assets/images/dineout/loyalty/Logo-Toggle.png";

export const getCartItemListFromBilledLineItems = (billedLineItems: IMetaData["bill"]["billedLineItems"] = []) => {
    return billedLineItems.map((item) => ({
        itemId: `${item?.label}`,
        itemName: item?.label || "",
        itemPrice: item?.value ?? 0,
        quantity: 0, // required props
        min: 0, // required props
        max: 0, // required props
        priceIconUrl: item?.leadingIconUrl || DINE_CASH_ICON_URL,
    }));
};

export const getCouponMetaDataFromBilledItems = (billedItems: IMetaData["bill"]["billedItems"] = []): ICouponMetaData => {
    const item = billedItems?.[0]?.item || {};
    const couponInfo = item?.couponInfo || {};

    return {
        restaurantImg: item?.images?.[0] || "",
        restaurantName: item?.name || "",
        couponTitle: couponInfo?.title || "",
        couponSubtitle: couponInfo?.subtitle || "",
        couponCode: couponInfo?.code || "",
        statusTimestamp: item?.statusTimestamp || 0,
        status: item?.status as ICouponMetaData["status"],
        logoId: item?.logoId || "",
    };
};

export const getVoucherSkuCardFromResponse = (
    voucherResponse?: IVoucherEntityResponse,
): IVoucherSkuCard | undefined => {
    const cards = voucherResponse?.success?.cards || [];
    const skuCard = cards?.find((item: IVoucherEntityCard) =>
        isEqual(item?.card?.card?.["@type"], VOUCHER_ENTITY_CARD_TYPES.SKU),
    )?.card?.card;

    return skuCard;
};

export const getVoucherEntityCardData = (voucherSkuCard?: IVoucherSkuCard): IVoucherEntityCardData | undefined => {
    const info = voucherSkuCard?.info;
    const vendorInfo = info?.vendorInfo;
    const imageUrl = info?.mediaFiles?.[0]?.url;
    const title = vendorInfo?.name?.info || info?.name?.info;

    if (!imageUrl || !title) {
        return;
    }

    return {
        imageUrl,
        title,
        subtitle: vendorInfo?.displayAddress?.info,
        rating: vendorInfo?.rating?.value,
        ctaLink: vendorInfo?.cta?.link,
        ctaType: vendorInfo?.cta?.type,
    };
};
